import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import MarathonsContent from '../../../components/Pages/Marathons/Shopping';

const { displayName } = config;

export default function MarathonShopping(): React.ReactNode | null {
  document.title = `${displayName}: Редактировать закупки`;

  return (
    <Layout>
      <MarathonsContent />
    </Layout>
  );
}
